export type VuexAssignmentActionNameList = "DETAILS_REQUEST" | "LIST_REQUEST" | "MINE";
export type VuexAssignmentActionNames = {
  [T in VuexAssignmentActionNameList]: string;
};

export type VuexAssignmentMutationNameList =
  | "ACTIVE_LIST"
  | "DETAILS"
  | "HISTORICAL_TOTAL"
  | "LIST"
  | "LOADING";
export type VuexAssignmentMutationNames = {
  [T in VuexAssignmentMutationNameList]: string;
};

export const VUEX_ASSIGNMENT_NAMESPACE = "assignment";

export const VUEX_ASSIGNMENT_ACTION_NAMES: VuexAssignmentActionNames = {
  DETAILS_REQUEST: "details_request",
  LIST_REQUEST: "list_request",
  MINE: "my_assignments"
};

export const VUEX_ASSIGNMENT_MUTATION_NAMES: VuexAssignmentMutationNames = {
  ACTIVE_LIST: "active_list",
  DETAILS: "details",
  HISTORICAL_TOTAL: "historical_total",
  LIST: "list",
  LOADING: "loading"
};
